// extracted by mini-css-extract-plugin
export default {"button":"BuyItRefurbished-button","link":"BuyItRefurbished-link","sellerCta":"BuyItRefurbished-sellerCta"};